import styled from 'styled-components';
import { rem } from 'polished';
import { TrimSelectStyled } from '../../TrimSelectStyled';

export const TrimSelectStyledOVGB = styled(TrimSelectStyled)`
    .trimTitle {
        font-size: ${rem(16)};

        .selectedBorder {
            border: 1px solid ${({ theme }) => theme.colors.primary};
        }
    }
    
    .trimContent {
        font-size: ${({ theme }) => theme.fontSizes.h5};
    }

    .isSelected {
        background: ${({ theme }) => theme.colors.red7};
    }
`;
